__webpack_require__.p = "/wp-content/themes/swan/public/dist/";